import {ControlButton} from "@ui/buttons/ControlButton";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const UnsavedPopup = (props) => {
  const {onClickYes, onClickNo} = props;
  const {t} = useTranslation();

  return (
    <div className={styles.unsavedPopup}>
      <h2 dangerouslySetInnerHTML={{__html: t("popup.unsaved.subtitle")}} />

      <div className={styles.buttons}>
        <ControlButton
          color={"var(--red)"}
          txt={t("button.yes_exit")}
          onClick={onClickYes}
        />

        <ControlButton
          color={"var(--green)"}
          txt={t("button.no_stay")}
          onClick={onClickNo}
        />
      </div>
    </div>
  );
};
